// logic/evalShared.js
export function safeGetRaw(answers, id) {
  const a = answers?.[id];
  if (a == null) return undefined;
  if (typeof a === "object" && "answer" in a) return a.answer;
  return a;
}

export function isYes(answers, id) {
  const v = Number(safeGetRaw(answers, id));
  if (Number.isNaN(v)) return undefined;
  return v === 1; // backend envia 1/0
}

export function getRange05(answers, id) {
  const v = Number(safeGetRaw(answers, id));
  if (Number.isNaN(v)) return undefined;
  return v; // 0..5
}

// Pega o label de uma opção "button"/"buttonImage" com base no "questions"
export function getOptionLabel(answers, questions, id) {
  const raw = safeGetRaw(answers, id);
  if (raw == null) return undefined;
  if (typeof raw === "string") return raw;

  // quando o answer é ans_id numérico, achamos o label na pergunta
  const q = Array.isArray(questions) ? questions.find(q => Number(q.sym_id) === Number(id)) : undefined;
  const opt = q?.answers?.find(o => Number(o.ans_id) === Number(raw));
  return opt?.label ?? String(raw);
}

// Normalizador 0..5 → 0..10 (com invert opcional)
export function norm05to10(value, { invert = false } = {}) {
  if (value == null) return null;
  const v = Number(value);
  if (Number.isNaN(v)) return null;
  const base = invert ? (5 - v) : v;
  return Math.max(0, Math.min(10, base * 2));
}

// Normalizador Sim/Não → 0 ou 10 (com invert opcional)
export function normYesNo(value, { invert = false } = {}) {
  if (value == null) return null;
  const v = Number(value);
  if (Number.isNaN(v)) return null;
  if (v !== 0 && v !== 1) return null;
  // invert=false: Sim=10; invert=true: Sim=0
  return invert ? (v === 1 ? 0 : 10) : (v === 1 ? 10 : 0);
}

// Cria objeto padrão de saída
export function baseResult() {
  return {
    sku: null,
    scores: {},
    regenera_flags: { G1: 0, G2: 0, G3: 0, G4: 0 },
    preliminarySKU: null,
    boostedScores: null,
    reasons: [],
    alerts: []
  };
}
